import { isFavouritesClientGetError } from '@johnlewispartnership/wtr-website-favourites-sdk';

import { logger } from 'logger';
import { getAllFavouritesNetworkErrorModal, unexpectedErrorModal } from 'constants/modals/modals';

export const getFavouritesQueryErrorModal = (error: unknown) => {
  if (isFavouritesClientGetError(error)) {
    logger.error({
      payload: {
        message: 'Failed to fetch favourites',
        service: 'favourites',
        errorDetails: {
          message: error.message,
          name: error.name,
          stack: error.stack,
        },
      },
    });

    return getAllFavouritesNetworkErrorModal;
  }

  const errorDetails = error instanceof Error ? error : {};

  logger.error({
    payload: {
      message: 'Failed to fetch favourites',
      service: 'favourites',
      errorDetails,
    },
  });

  return unexpectedErrorModal;
};
